import { useUploadEvidenceMutation } from "./../../../../services/clientserviceterms";
import toast from "react-hot-toast";

export const useUploadEvidence = () => {
    const [upload, {isLoading}] = useUploadEvidenceMutation();

    const uploadEvidence = (request) : Promise<any> => new Promise((resolve, reject) => {

        const fileRequest = new FormData();
        fileRequest.append('attachment', request.fileData!, request.fileData!.name);
        fileRequest.append('feeAgreementId', request.feeAgreementId);
        fileRequest.append('signedDate', request.signedDate);
        
        return toast.promise(upload({data: fileRequest}).unwrap(), {
            loading: 'Uploading evidence...',
            success: (data: any) => {
                resolve(data);
                return `Evidence updated successfully.`;
            },
            error: (err) => {
                reject();
                return `There was an error uploading the evidence`;
            }
        });
    });

    return {
        isLoading,
        uploadEvidence
    }
};